export default __webpack_public_path__ + "static/media/8k_earth_nightmap.c0e138e9.jpeg";